import { styled } from 'styled-components'

export const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(3px);
`

export const DialogContainer = styled.div`
  width: 450px;
  max-width: 90vw;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.25);
  transform: translateY(0);
  animation: dialogEntrance 0.3s ease;

  @keyframes dialogEntrance {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`

export const DialogContent = styled.div`
  background-color: white;
  display: flex;
  flex-direction: column;
`

export const DialogHeader = styled.div`
  background: ${(props) => props.theme.button.blue};
  padding: 24px;

  h2 {
    margin: 0;
    font-size: 22px;
    font-weight: 500;
    color: white;
    text-align: center;
  }
`

export const DialogBody = styled.div`
  padding: 32px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;

  p {
    color: #555;
    font-size: 16px;
    text-align: center;
    margin: 0 0 24px 0;
  }
`

export const WarningIcon = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-color: #fff3cd;
  color: #ffc107;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  font-size: 32px;
`

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 16px 24px 24px;
  gap: 12px;
  background-color: #f8f9fa;
  border-top: 1px solid #eee;
`

export const Button = styled.button`
  padding: 12px 24px;
  border-radius: 8px;
  border: none;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

export const CancelButton = styled(Button)`
  background-color: #f1f3f5;
  color: #495057;

  &:hover:not(:disabled) {
    background-color: #dee2e6;
  }
`

export const ConfirmButton = styled(Button)`
  background-color: ${(props) => props.theme.primary.darker};
  color: white;

  &:hover:not(:disabled) {
    filter: brightness(1.1);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  }
`
